import { render, staticRenderFns } from "./SubFour.vue?vue&type=template&id=e5f8a89a&"
import script from "./SubFour.vue?vue&type=script&lang=js&"
export * from "./SubFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports